import { render, staticRenderFns } from "./CalcFormItemGenericLoadCfg.vue?vue&type=template&id=8fceca58&scoped=true&"
import script from "./CalcFormItemGenericLoadCfg.vue?vue&type=script&lang=js&"
export * from "./CalcFormItemGenericLoadCfg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fceca58",
  null
  
)

export default component.exports